import * as motion from "motion/react-client";
import { animate, useMotionValue, useTransform } from "motion/react";
import { useEffect } from "react";
import { title } from "./primitives";

export function PrettyDate() {
	const count = useMotionValue(0);
	const rounded = useTransform(() => Math.round(count.get()));

	useEffect(() => {
		const controls = animate(count, 12, { duration: 1, delay: 1.3 });
		return () => controls.stop();
	}, [count]);

	return (
		<motion.span className={title({ color: "gold", size: "xl" })}>
			{rounded}
		</motion.span>
	);
}
